module.exports = __webpack_public_path__ + "static/media/codepen-animated-balls.b9a47d81.mp4";